import "./Contact.module.css";
import CorporateHeader from "@/reusable_sections/Header";
import DirectConnection from "./sections/DirectConnection";
import GlobalLogistics from "./sections/GlobalLogistics";
import QuoteProcessFaq from "./sections/QuoteProcessFaq";
import GlobalFooter from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <CorporateHeader />
      <DirectConnection />
      <GlobalLogistics />
      <QuoteProcessFaq />
      <GlobalFooter />
    </div>;
}